"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _SearcherEmpty["default"];
  }
});
var _SearcherEmpty = _interopRequireDefault(require("./SearcherEmpty"));